<template>
  <article class="aroma-home-card">
    <time>{{ date }}</time>
    <h2>昨晚睡眠记录已生成</h2>
    <p>这里展示本次睡眠的关键数据，更多详情可进入完整报告查看。</p>
    <div v-if="detailError" class="aroma-home-card__detail-error">
      <span>关键数据加载失败</span><button type="button" @click="$emit('retry')">重试</button>
    </div>
    <template v-else>
      <dl class="aroma-home-card__metrics">
        <div><dt>睡眠时长</dt><dd>{{ metrics.duration }}</dd></div>
        <div><dt>入睡用时</dt><dd>{{ metrics.latency }}</dd></div>
        <div><dt>夜醒次数</dt><dd>{{ metrics.awakeCount }}</dd></div>
        <div><dt>睡眠效率</dt><dd>{{ metrics.efficiency }}</dd></div>
      </dl>
      <aroma-home-stage-timeline :timeline="timeline" />
    </template>
    <van-button block @click="$emit('open')">查看完整报告</van-button>
  </article>
</template>

<script>
import AromaHomeStageTimeline from './AromaHomeStageTimeline.vue'
export default {
  name: 'AromaHomeReportCard',
  components: { AromaHomeStageTimeline },
  props: {
    date: { type: String, default: '--' },
    metrics: { type: Object, required: true },
    timeline: { type: Object, default: null },
    detailError: { type: Boolean, default: false }
  }
}
</script>

<style scoped lang="scss">
.aroma-home-card { padding: 20px; border-radius: 8px; background: #fff; box-shadow: 0 8px 24px rgba(38,48,82,.06); }
.aroma-home-card > time { color: #858c99; font-size: 13px; }
.aroma-home-card > h2 { margin: 14px 0 4px; color: #242c40; font-size: 21px; line-height: 30px; }
.aroma-home-card > p { margin: 0 0 16px; color: #9298a5; font-size: 13px; line-height: 21px; }
.aroma-home-card__metrics { display: grid; grid-template-columns: repeat(2,1fr); margin: 0 0 14px; border: 1px solid #edf0f5; border-radius: 8px; }
.aroma-home-card__metrics div { min-height: 74px; padding: 12px 14px; box-sizing: border-box; }
.aroma-home-card__metrics div:nth-child(odd) { border-right: 1px solid #edf0f5; }.aroma-home-card__metrics div:nth-child(-n+2) { border-bottom: 1px solid #edf0f5; }
.aroma-home-card__metrics dt { color: #9aa0ab; font-size: 12px; }.aroma-home-card__metrics dd { margin: 5px 0 0; color: #27314e; font-size: 21px; font-weight: 700; }
.aroma-home-card__detail-error { display: flex; min-height: 116px; align-items: center; justify-content: center; flex-direction: column; gap: 10px; color: #8d94a2; font-size: 14px; }
.aroma-home-card__detail-error button { border: 0; color: #596afd; background: transparent; font-size: 14px; }
.aroma-home-card > .van-button { height: 46px; margin-top: 14px; border: 0; border-radius: 6px; color: #596afd; background: #eef0ff; font-size: 16px; font-weight: 600; }
</style>
